import CSDToggle from '@cloudscape-design/components/toggle';
import { Controller, useFormContext } from 'react-hook-form';

type ToggleProps = {
  name: string;
  label?: string;
  description?: string;
  defaultValue?: boolean;
  disabled?: boolean;
};

const Toggle = ({
  name,
  label,
  description,
  defaultValue = false,
  disabled = false,
}: ToggleProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <CSDToggle
          {...field}
          disabled={disabled}
          onChange={({ detail }) => field.onChange(detail.checked)}
          checked={field.value ?? defaultValue}
          description={description}
        >
          {label}
        </CSDToggle>
      )}
    />
  );
};

export default Toggle;
